import { forwardRef } from 'react';

import { Header } from './Header';
import { HeaderSlots } from './HeaderSlots';
import type { HeaderVariant, RootHeaderProps } from './types';

const HeaderNamespace = Header as typeof Header & {
  Address: typeof HeaderSlots.Address;
  MainShopCategories: typeof HeaderSlots.MainShopCategories;
  Navigation: typeof HeaderSlots.Navigation;
} & Record<
    HeaderVariant,
    React.ForwardRefExoticComponent<
      Omit<RootHeaderProps, 'ref' | 'variant'> &
        React.RefAttributes<HTMLDivElement>
    >
  >;

HeaderNamespace.MCosmetic = forwardRef<
  HTMLDivElement,
  Omit<RootHeaderProps, 'variant'>
>(({ children, ...props }, ref) => (
  <Header {...props} variant="MCosmetic" ref={ref}>
    {children}
  </Header>
));

HeaderNamespace.Address = HeaderSlots.Address;
HeaderNamespace.MainShopCategories = HeaderSlots.MainShopCategories;
HeaderNamespace.Navigation = HeaderSlots.Navigation;

export { HeaderNamespace as Header, HeaderSlots };
